import { Link } from 'react-router'

import { FeatureBox } from '@writefull/core'

import { Page } from '@ui/app/domain/page'
import Container from '@ui/shared/components/Container'

interface HomeProps {
  features: Page[]
}

export default function Home({ features }: HomeProps) {
  return (
    <Container className='grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-14 justify-center py-12'>
      {features.map((page) => (
        <Link to={page.path} key={page.name}>
          <FeatureBox name={page.name} description={page.title} icon={page.icon} />
        </Link>
      ))}
    </Container>
  )
}
